import type { ChatParticipant } from '@/types/teacher-chat'

export function ParticipantBadge({ participant }: { participant: ChatParticipant }) {
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] border"
      style={{
        backgroundColor: `${participant.color}10`,
        borderColor: `${participant.color}30`,
        color: participant.color,
      }}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ backgroundColor: participant.color }}
      />
      {participant.teacher_name}
      {participant.is_requesting_teacher && (
        <span className="text-[9px] opacity-60">(Anfragende)</span>
      )}
    </span>
  )
}
